import * as wooutils from "./utils.js";
import * as tracking from "../tracking.js";

export function init() {
  //  console.log("cart init");
  // jQuery(".product-remove a").on("click", function (e) {

  //     e.stopPropagation();
  //     var cart_item = jQuery(this).attr("data-cart_item_key");
  //     console.log("remove cart_item: ", cart_item);
  //     wooutils.remove_from_cart(cart_item);
  // });

  // jQuery(".single_add_to_cart_button").on("click", function () {
  //     gtm_addtocart()
  // });

  // jQuery(".add_to_cart_button").on("click", function () {
  //     gtm_addtocart()
  // });

  /*****REMOVE FROM SHOPPING CART */
  jQuery(".minicart").on("click", ".remove_from_cart_button", function (e) {
    e.stopPropagation();
    var cart_item = jQuery(this).attr("data-cart_item_key");

    wooutils.remove_from_cart(cart_item);
  });
}

export function refreshCart() {
  if (jQuery("body").hasClass("woocommerce-cart")) {
    jQuery(
      ".woocommerce-shipping-totals .woocommerce-shipping-destination"
    ).html(
      jQuery(".woocommerce-shipping-totals .woocommerce-shipping-destination")
        .html()
        .replace("Shipping to", "")
    );
  }
}
